import {
  DEAL_VIEW_PATH,
  HOME_PATH,
  SELECTION_ID_PATH,
  SELECTION_PATH
} from './constants.routes'

import { MANAGER, ROP, ROP_CS, SUPER_HEAD_SALES } from 'constants/roles'
import HomeManagerMobile from 'pages/Mobile/Home/Manager/Home.manager.mobile'
import HomeRopMobile from 'pages/Mobile/Home/Rop/Home.rop.mobile'
import WorkListViewRopMobile from 'pages/Mobile/WorkListView/Rop/WorkListView.rop.mobile'
import WorkListViewManagerMobile from 'pages/Mobile/WorkListView/Manager/WorkListView.manager.mobile'
import SelectionMnMobile from 'pages/Mobile/Selection/Manager/Selection.manger.mobile'
import HomeRopDesktop from 'pages/Desktop/Home/Rop/Home.rop.desktop'

export const mobileRoutes = role => {
  const ropRoutes = [
    {
      path: HOME_PATH,
      component: HomeRopDesktop,
      byRole: [ROP, ROP_CS, SUPER_HEAD_SALES]
    },
    {
      path: DEAL_VIEW_PATH + '/:id',
      component: WorkListViewRopMobile,
      byRole: [ROP, ROP_CS, SUPER_HEAD_SALES]
    }
  ]

  const managerRoutes = [
    {
      path: HOME_PATH,
      component: HomeManagerMobile,
      byRole: MANAGER
    }
  ]
  return role === MANAGER ? managerRoutes : ropRoutes
}

export const managerSubRoutes = [
  {
    path: `${HOME_PATH}${DEAL_VIEW_PATH}/:id`,
    component: WorkListViewManagerMobile,
    byRole: MANAGER
  },
  {
    path: `${HOME_PATH}${SELECTION_ID_PATH}/:step`,
    component: SelectionMnMobile,
    byRole: MANAGER
  },
  {
    path: `${HOME_PATH}${SELECTION_PATH}/:step`,
    component: SelectionMnMobile,
    byRole: MANAGER
  }
]
